module.exports = __webpack_public_path__ + "img/introducePage_show_four.19ad064f.jpg";